import type { FaireProductEntity } from "../../entity_types/product";

export const p_yjh7fym9ek: FaireProductEntity = {
  token: "p_yjh7fym9ek",
  type: "product",
  name: "Abstract Beauty Body Charm 18K Gold Plated SS Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/8f3bd753eaa8a7a59bcb69f2fb37f0879eee62b8f7923ea022790a42b30149bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/185979fd32d2b529362b6b51b8f629f745b9853efdf6cf4b814ee68fdf93598e.jpeg",
    "https://cdn.faire.com/fastly/7689e16e62ea20d1d62cc49e2d91fe83713d277c122d23cfae72b36633fe194c.jpeg",
    "https://cdn.faire.com/fastly/c997eaf4f040d4e018991fbe3c88f95c409795b32d032cb696bc3f8312c251d8.jpeg",
    "https://cdn.faire.com/fastly/f59a1439e839f9cb07ab079ab694684efad9ae4aa4e0aab2a41ddd3853c2f404.jpeg"
  ],
  priceDollars: 7.46,
  description: "\nType: pendant necklace\n\nMaterial: 316L Stainless steel ，18K gold plated\n\nSize of pendant ： 10mm * 28mm \n\nLength of chain ： 400mm +50mm\n\nProcess: Vacuum electroplating and manual polishing,Non tarnish\n\nSurface : High Polish\n\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 14.92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:57.692Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
